import { CargoType } from '@/models/CargoType'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<CargoType>(CargoType, {
	namespaced: true
})
